import Cookies from "universal-cookie";

export const KEY = "accessToken";
export const ATTENDANCE_ID = "attendanceId";
export const STORE_ID_KEY = "store";
export const SHIFT_INFO_KEY = "shift";

// const getAccountExpiresBase = () => {
//   const expiresDate = new Date();
//   expiresDate.setDate(expiresDate.getDate() + 30);
//   return expiresDate;
// };
const addUserLocalStorage = (token, userInfo) => {
  try {
    const oneDayInMilliseconds = new Date().getTime() + 24 * 60 * 60 * 1000;
    const cookies = new Cookies();

    // Lưu token vào cookies với thời gian expire
    cookies.set(
      KEY,
      { token: "Bearer " + token },
      { path: "/", maxAge: oneDayInMilliseconds }
    );

    // Lưu userLogin vào localStorage
    localStorage.setItem(
      "userInfo",
      JSON.stringify({ ...userInfo, expires: oneDayInMilliseconds })
    );
  } catch (error) {
    console.error("Error adding user information:", error);
  }
};
const removeUserLocalStorage = () => {
  try {
    const cookies = new Cookies();

    // Xóa token ở cookies
    cookies.remove(KEY, { path: "/" });

    // Lưu userLogin vào localStorage
    localStorage.removeItem("userInfo");
  } catch (error) {
    console.error("Error adding user information:", error);
  }
};

const addUserToCookies = (token, dateExpires) => {
  const cookies = new Cookies();
  cookies.set(
    KEY,
    { token: "Bearer " + token },
    { expires: dateExpires, path: "/" }
  );
};

// const addUserDefaultLinkBaseToLocalStorage = (role, link) => {
//   const cookies = new Cookies();
//   const userCookies = getUserLogin();
//   if (userCookies) {
//     cookies.set(KEY, { ...userCookies, role, link }, { path: "/" });
//   } else {
//     cookies.set(KEY, { role, link }, { path: "/" });
//   }
// };

// const addUserDefaultLinkBaseToCookies = (role, link) => {
//   const cookies = new Cookies();
//   const userCookies = getUserLogin();
//   if (userCookies) {
//     cookies.set(
//       KEY,
//       { ...userCookies, role, link },
//       { expires: getAccountExpiresBase(), path: "/" }
//     );
//   } else {
//     cookies.set(
//       KEY,
//       { role, link },
//       { expires: getAccountExpiresBase(), path: "/" }
//     );
//   }
// };

const clearUserFromCookies = () => {
  const cookies = new Cookies();
  cookies.remove(KEY, { path: "/" });
};
const getUserLogin = () => {
  const cookies = new Cookies();

  const userCookies = cookies.get(KEY);
  if (userCookies) {
    return userCookies;
  }
  return "";
};

// const temporarilyStore = (storeId, internalId) => {
//   const cookies = new Cookies();
//   cookies.set(
//     STORE_ID_KEY,
//     { storeId: storeId || "", internalId: internalId || "" },
//     { path: "/" }
//   );
// };

// const saveStoreHaveExpires = (storeId, dateExpires) => {
//   const cookies = new Cookies();
//   cookies.set(
//     STORE_ID_KEY,
//     { storeId: storeId },
//     { expires: dateExpires, path: "/" }
//   );
// };

// const getStoreIdSave = () => {
//   const cookies = new Cookies();

//   const cookieStore = cookies.get(STORE_ID_KEY);
//   if (cookieStore) {
//     return cookieStore?.storeId || cookieStore;
//   }
//   return null;
// };

// const getInternalIdStoreSave = () => {
//   const cookies = new Cookies();

//   const cookieStore = cookies.get(STORE_ID_KEY);
//   if (cookieStore) {
//     return cookieStore?.internalId || cookieStore;
//   }
//   return null;
// };

// const addInfoShiftToCookies = ({ store, timeStartShift }) => {
//   const cookies = new Cookies();
//   cookies.set(
//     SHIFT_INFO_KEY,
//     { store, timeStartShift },
//     { expires: getAccountExpiresBase(), path: "/" }
//   );
// };

// const getShiftInfoInCookies = () => {
//   const cookies = new Cookies();

//   const shiftInfo = cookies.get(SHIFT_INFO_KEY);
//   if (shiftInfo) {
//     return shiftInfo;
//   }
//   return null;
// };
export {
  addUserLocalStorage,
  removeUserLocalStorage,
  addUserToCookies,
  clearUserFromCookies,
  getUserLogin,
  // temporarilyStore,
  // saveStoreHaveExpires,
  // getStoreIdSave,
  // getInternalIdStoreSave,
  // getAccountExpiresBase,
  // addUserDefaultLinkBaseToLocalStorage,
  // addUserDefaultLinkBaseToCookies,
  // addInfoShiftToCookies,
  // getShiftInfoInCookies,
};
